import React, { useState } from 'react';
import { MenuItem } from '@mui/material';

import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { getTranslateByKey } from '@/main/services/utils';
import { userIsSupplier } from '@/main/services/utilsUser';
import ModalImages from '@/main/components/shared/modalImages/modalImages';
import { useThreeDotsClaimContext } from '../contex';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';
import { Controls } from '@/main/services/constants/constantsControl';

interface IThreeDotsClaimImageProps {
  guidClaim: string; 
  isQuoteCanceled: boolean;
}
function ThreeDotsClaimImage({
  isQuoteCanceled,
  guidClaim
}: IThreeDotsClaimImageProps) {
  const {
    closeThreeDotsClaim,
    generateIdMenu,
  } = useThreeDotsClaimContext();
  const [openModalImages, setOpenModalImages] = useState<boolean>(false);

  function handleClick() {
    setOpenModalImages(true)
    closeThreeDotsClaim();
  }
  function closeModalImages() {
    setOpenModalImages(false);
  }

  const isSupplier = userIsSupplier();

  return (
    <>
      <MenuItem
        id={generateIdMenu('image')}
        onClick={handleClick}
      >
        {getTranslateByKey('information.images')} / {getTranslateByKey('information.files')}
      </MenuItem>

      <ModalImages
        isOpenModal={openModalImages}
        closeModal={closeModalImages}
        setIsOpenModal={setOpenModalImages}
        canUploadImages={!isQuoteCanceled && !isSupplier}
        canShowPDF={!isSupplier}
        guidQuote={''}
        guidClaim={guidClaim}
        removeDeleteButton
        canDownloadImages={useKogControlElementId(Controls.IdDownloadImagesSearchClaimsControl)}
      />
    </>
  )
}

export { ThreeDotsClaimImage };
